// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Flex, Tag, Typography } from '@iheartjane/reefer';
import { Form } from '@iheartjane/reefer-hook-form';

import type { Store } from './StoreSelectModal';
import { idConversions } from './util/idConversions';

const concatAddress = (store: Store): string => {
  return `${store.address}${store.address2 ? `, ${store.address2}` : ''}, ${
    store.city
  }, ${store.state} ${store.zip}`;
};

const StyledStoreWrapper = styled(Flex)<{ isHidden: boolean }>(
  ({ isHidden }) => ({
    ...(isHidden && { display: 'none' }),
  })
);

export const StoreRow = ({
  handleChange,
  isChecked,
  isHidden = false,
  store,
}: {
  handleChange: (checked: boolean) => void;
  isChecked?: boolean;
  isHidden?: boolean;
  store: Store;
}) => {
  const stringifiedId = `stores.${idConversions.asString(store.id)}.enabled`;

  const tagProps = store.recreational
    ? ({
        label: 'Rec',
        color: 'primary-dark',
        background: 'primary-light',
      } as const)
    : ({
        label: 'Med',
        color: 'palm-dark',
        background: 'palm-light',
      } as const);

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <StyledStoreWrapper
        isHidden={isHidden}
        my={16}
        alignItems="center"
        gap={16}
      >
        <Flex gap={16} mx={8}>
          <Form.SwitchField
            label={stringifiedId}
            labelHidden
            name={stringifiedId}
            defaultChecked={isChecked}
            checked={isChecked}
            shouldUnregister={false}
            onChange={handleChange}
          />
        </Flex>
        <Tag {...tagProps} />
        <div>
          <Typography variant="body-bold">{store.name}</Typography>
          <Typography color="grays-mid">{concatAddress(store)}</Typography>
        </div>
      </StyledStoreWrapper>
    </Flex>
  );
};
